import { GetterTree } from "vuex";
import { State } from "@/store/modules/mq/mqCommonState/mq.store";

const getters: GetterTree<State, State> = {
    getCurrentMQType: (state) => {
      return state.currentMQType;
    },
    getCurrentMQService: (state) => {
      return state.currentMQService;
    },
    getCurrentBroker: (state) => {
        return state.currentBroker;
    },
    getCurrentMQSubType: (state) => {
        return state.currentMQSubType;
    },
    getBrokerVersionList: (state) => {
      return state.brokerVersionList;
    },
    getQueueList: (state) => {
      return state.queueList;
    },
    getTopicList: (state) => {
      return state.topicList;
    },
    getProducerList: (state) => {
      return state.producerList;
    },
    getCurrentProducer: (state) => {
      return state.currentProducer;
    },
    getConsumerList: (state) => {
      return state.consumerList;
    },
    getZookeeperList: (state) => {
      return state.zookeeperList;
    },
    getBrokerList: (state) => {
      return state.brokerList;
    },
    getBrokerTopicList: (state) => {
      return state.brokerTopicList;
    }
  };
  
  export default getters;